import React from "react";
import { ColumnValueRendererProps, EmailColumnValue } from "../table.data.interface";
import { Tooltip } from "@vibe/core";

const EmailColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  if (
    columnData.value === "Empty Column" ||
    (!columnData?.text && isPreview) ||
    (!columnData?.value && otherBoardsValues)
  ) {
    return null;
  }

  const columnValue = columnData?.value;
  const textFromValue =
    columnValue != null && typeof columnValue === "object" && "text" in columnValue
      ? (columnValue as EmailColumnValue).email
      : undefined;
  const value = otherBoardsValues
    ? textFromValue
    : isPreview
      ? columnData?.text
      : columnData?.value;

  const displayValue = typeof value === "string" ? value : "";

  if (isPreview) {
    return (
      <div className="overflow-hidden whitespace-nowrap text-ellipsis">
        <Tooltip content={displayValue}>
          <span>{displayValue}</span>
        </Tooltip>
      </div>
    );
  }

  return (
    <div>
      <a href={`mailto:${displayValue}`} className="no-underline cursor-pointer hover:underline">
        {displayValue}
      </a>
    </div>
  );
};

export default EmailColumn;
